import { ChildWithParentsIds, JournalChildWithParentsBasicInfoDto } from 'types';
import { journalChildDTOFields } from 'consts/child/journalChildDTOFields';

export const parseJournalChildDTOIntoChildWithParentsIds: (
    journalChildDTO: JournalChildWithParentsBasicInfoDto,
) => ChildWithParentsIds = (journalChildDTO) => {
    const parentIds = journalChildDTO[journalChildDTOFields.parents].map((parent) => parent.id);
    return {
        childId: journalChildDTO[journalChildDTOFields.id],
        parentIds,
    };
};
